import PageContainer from '@/common/components/PageContainer'
import { PermissionType } from '@/common/types'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'

import DepositByIdListing from '@/modules/transaction/components/DepositByIdListing'

function DepositByIdPage() {
	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<DepositByIdListing />
			</div>
		</PageContainer>
	)
}

const GuardedDepositByIdPage = withUserPermission(DepositByIdPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_BANK_TRANSACTION],
})

export default GuardedDepositByIdPage
